<!-- 搜索页面 -->
<template>
  <div class="casewrap">
    <div class="search">
      <form action="/">
        <van-search v-model="searchModel.dataName" show-action placeholder="搜索云课堂、医学资料名称..." @search="onSearch" @cancel="onCancel" />
      </form>
    </div>

    <!-- 选项 -->
    <div class="bq_top">
      <div :class="active == index ? 'bq bq1' : 'bq bq2' " @click="change(index,item)" v-for="(item,index) in firstNavData" :key="item.id">{{item.seriesName}}</div>
    </div>
    <!-- <div v-if="dataList.length > 0"> -->
      <van-tabs @change="onChange" v-model="searchModel.courseStatus">
        <van-tab title="即将开课"></van-tab>
        <van-tab title="往期回顾"></van-tab>
      </van-tabs>
    <!-- </div> -->
    <div id='la' class="img_detail">
      <!-- 数据列表 -->
      <div>
        <listContent :listData="dataList"></listContent>
            <div v-if="dataList.length == 0" class="local">
        <div class="noData">暂无数据，请联系管理员上传相应资料</div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import listContent from '../../../../components/basics/list-content.vue';
export default {
  components: { listContent },
  data () {
    return {
      pageCount: 1,
      isPush: true, // 用于锁定，防止连续拉动刷新调用接口
      active: 0, // 选中的标签
      hisList: [],
      // 一级导航栏内容
      firstNavData: [],
      // 下方数据内容
      dataList: [],
      // 初始化搜索数据
      searchModel: {
        current: 1,
        dataName: '',
        size: 8,
        sortType: 1,
        courseStatus: 0, // 0，即将开课，1.往期回顾，不传默认全部
        moduleId: 6,
        seriesId: ''
      }
    };
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created () {
    this.searchModel.moduleId = this.$route.query.moduleId;
    this.searchModel.seriesId = this.$route.query.seriesId;
    this.info();
    this.onSearch();
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted () {
    this.listen();
  },
  methods: {
    onChange () {
      if (this.searchModel.courseStatus === 0) {
        this.searchModel.sortType = 0;
      } else {
        this.searchModel.sortType = 1;
      }
      this.isPush = true;
      this.onSearch();
    },
    // 监听滚动条
    listen () {
      const scrollElement = document.querySelector('#la');
      scrollElement.addEventListener(
        'scroll',
        () => {
          const bottom =
            scrollElement.scrollHeight -
            scrollElement.scrollTop -
            scrollElement.clientHeight;
          if (bottom < 50 && this.isPush) {
            this.isPush = false;
            this.onload();
          }
        },
        false
      );
    },
    // 按钮展示
    info () {
      //   const data = {
      //     platformId: JSON.parse(localStorage.getItem('userInfo')).platformId
      //   };
      //   const Version = this.$version;
      this.$axios.post('edu/home/page/series/list').then((res) => {
        this.firstNavData = res.data;
        this.firstNavData.unshift({ seriesName: '全部' });
      });
    },
    // 下拉加载
    onload () {
      if (this.searchModel.current < this.pageCount) {
        const scrollElement = document.querySelector('#la');
        scrollElement.scrollTop = 0;
        this.searchModel.current = this.searchModel.current + 1;
        const Data = this.searchModel;
        this.$axios
          .post('/edu/home/page/mobile/search', { data: Data })
          .then((res) => {
            this.dataList = this.dataList.concat(res.data.list);
            this.pageCount = res.data.pageCount;
            this.searchModel.current = res.data.current;
            this.isPush = true;
          });
      }
    },
    //  回车搜索框
    onSearch () {
      this.isPush = true;
      //   查询有值
      this.show = 2;
      this.searchModel.current = 1;
      const Data = this.searchModel;
      this.$axios
        .post('/edu/home/page/mobile/search', { data: Data })
        .then((res) => {
          this.dataList = res.data.list;
          this.pageCount = res.data.pageCount;
          this.searchModel.current = res.data.current;
          //   this.listen()
        });
    },
    // 取消
    onCancel () {
      history.back();
    },
    // 点击选项卡筛选
    change (index, item) {
      this.active = index;
      this.searchModel.seriesId = item.id;
      this.onSearch();
    }
  }
};
</script>
<style scoped lang="scss">
/* @import url(); 引入css类 */
.local {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
}
.noData {
  width: 50vw;
  font-size: 20px;
  color: rgb(204, 199, 194);
  margin-top: 30vh;
}
.casewrap {
  position: relative;
  z-index: 11;
  margin-bottom:-56px;
}
.search {
  height: 52px;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: $white;
  z-index: 9;
  .van-search {
    padding-left: 10px !important;
  }
  .van-search__action {
    width: 60px;
  }
}
.his {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.his :nth-child(1) {
  font-size: 18px;
}
.his :nth-child(2) {
  font-size: 14px;
  color: red;
}
.his_list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
}
.his_list_block {
  display: flex;
  justify-items: center;
  align-items: center;
  margin-right: 10px;
  margin-top: 10px;
  padding: 0 10px;
  background-color: #f2f2f2;
  height: 30px;
  font-size: 12px;
  border-radius: 25%;
}
.bq_top {
  display: flex;
  overflow-x: auto;
  padding: 20px;
}
.bq_top::-webkit-scrollbar {
  display: none;
}
.bq {
  flex: none;
  display: flex;
  justify-items: center;
  align-items: center;
  margin-right: 10px;
  margin-top: 10px;
  padding: 0 10px;
  height: 30px;
  font-size: 12px;
  border-radius: 25%;
}
.bq1 {
  background-color: rgba(255, 234, 221);
  color: rgba(254, 111, 38);
}
.bq2 {
  background-color: #f2f2f2;
}
.img_detail {
  overflow-y: auto;
  max-height: calc(100vh - 100px);
  padding-bottom: 10px;
}
.img {
  width: 100%;
  padding: 20px;
  display: flex;
}
.img_pic {
  width: 100px;
  height: 100%;
}
.img_content {
  width: 100%;
  padding-left: 20px;
  font-size: 10px;
  color: rgb(136, 135, 136);
  div {
    font-size: 12px;
  }
}
.img_content :nth-child(1) {
  color: black;
  font-size: 18px;
  font-weight: 700;
}
</style>
